import { render, staticRenderFns } from "./MarginsMenu.vue?vue&type=template&id=54434e62"
import script from "./MarginsMenu.vue?vue&type=script&lang=js"
export * from "./MarginsMenu.vue?vue&type=script&lang=js"
import style0 from "./MarginsMenu.vue?vue&type=style&index=0&id=54434e62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports